module.exports = __webpack_public_path__ + "static/media/tabiona1.2407b22f.jpg";